import axios from './axios.interceptor';
import api from './api.util';

export const SUB_ADMIN_URL = `${api}/account/admin/admin-user`;
export const ADD_SUB_ADMIN_URL =`${SUB_ADMIN_URL}/add`;
export const LIST_SUB_ADMIN_URL =`${SUB_ADMIN_URL}/list`;

export function addSubAdmin(payload) {
  return axios.post(ADD_SUB_ADMIN_URL, payload);
}

export function listSubAdmin({skip, limit}) {
  return axios.post(`${LIST_SUB_ADMIN_URL}?skip=${skip}&limit=${limit}`);
}

export function editSubAdmin(subAdminId, payload) {
  return axios.put(`${SUB_ADMIN_URL}/${subAdminId}`, payload);
}

export function removeSubAdmin(subAdminId) {
  return axios.delete(`${SUB_ADMIN_URL}/${subAdminId}`);
}